// DS: i10.3
import React from 'react';
import IconWrap from '../IconWrap';
const Pinterest = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M12.338 3C7.46 3 5 6.442 5 9.313c0 1.738.669 3.284 2.103 3.86.235.095.445.004.514-.252.047-.178.16-.625.21-.811.068-.254.041-.343-.148-.564C7.265 11.066 7 10.445 7 9.565c0-2.554 1.941-4.84 5.055-4.84 2.757 0 4.272 1.658 4.272 3.872 0 2.914-1.31 5.373-3.255 5.373-1.074 0-1.878-.874-1.62-1.946.308-1.28.906-2.662.906-3.586 0-.827-.451-1.517-1.385-1.517-1.098 0-1.98 1.118-1.98 2.615 0 .954.328 1.6.328 1.6L8 16.641c-.392 1.634-.059 3.638-.03 3.84.016.12.172.149.243.058.101-.13 1.41-1.719 1.854-3.307.126-.45.722-2.778.722-2.778.357.67 1.4 1.26 2.508 1.26 3.3 0 5.54-2.962 5.54-6.926 0-2.997-2.58-5.789-6.5-5.789"
    }))));
Pinterest.displayName = 'Pinterest';
export default Pinterest;
